import { c as G, a as V } from "./_commonjsHelpers-OnjxAlhP.js";
var P = { exports: {} };
/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v5.2.12
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */
(function(I, z) {
  (function(d, i) {
    I.exports = i();
  })(G, function() {
    return (
      /******/
      function(p) {
        var d = {};
        function i(s) {
          if (d[s])
            return d[s].exports;
          var o = d[s] = {
            /******/
            exports: {},
            /******/
            id: s,
            /******/
            loaded: !1
            /******/
          };
          return p[s].call(o.exports, o, o.exports, i), o.loaded = !0, o.exports;
        }
        return i.m = p, i.c = d, i.p = "", i(0);
      }([
        /* 0 */
        /***/
        function(p, d) {
          p.exports = function() {
            if (typeof document > "u" || typeof window > "u")
              return {
                // always return "initial" because no interaction will ever be detected
                ask: function() {
                  return "initial";
                },
                // always return null
                element: function() {
                  return null;
                },
                // no-op
                ignoreKeys: function() {
                },
                // no-op
                specificKeys: function() {
                },
                // no-op
                registerOnChange: function() {
                },
                // no-op
                unRegisterOnChange: function() {
                }
              };
            var i = document.documentElement, s = null, o = "initial", a = o, x = Date.now(), g = !1, T = ["button", "input", "select", "textarea"], u = [], M = [
              16,
              // shift
              17,
              // control
              18,
              // alt
              91,
              // Windows key / left Apple cmd
              93
              // Windows menu / right Apple cmd
            ], w = [], y = {
              keydown: "keyboard",
              keyup: "keyboard",
              mousedown: "mouse",
              mousemove: "mouse",
              MSPointerDown: "pointer",
              MSPointerMove: "pointer",
              pointerdown: "pointer",
              pointermove: "pointer",
              touchstart: "touch",
              touchend: "touch"
              // boolean: true if the page is being scrolled
            }, v = !1, h = {
              x: null,
              y: null
              // map of IE 10 pointer events
            }, D = {
              2: "touch",
              3: "touch",
              // treat pen like touch
              4: "mouse"
              // check support for passive event listeners
            }, b = !1;
            try {
              var K = Object.defineProperty({}, "passive", {
                get: function() {
                  b = !0;
                }
              });
              window.addEventListener("test", null, K);
            } catch {
            }
            var A = function() {
              y[C()] = "mouse", N();
            }, N = function() {
              var e = b ? { passive: !0, capture: !0 } : !0;
              document.addEventListener("DOMContentLoaded", U, !0), window.PointerEvent ? (window.addEventListener("pointerdown", c, !0), window.addEventListener("pointermove", m, !0)) : window.MSPointerEvent ? (window.addEventListener("MSPointerDown", c, !0), window.addEventListener("MSPointerMove", m, !0)) : (window.addEventListener("mousedown", c, !0), window.addEventListener("mousemove", m, !0), "ontouchstart" in window && (window.addEventListener("touchstart", c, e), window.addEventListener("touchend", c, !0))), window.addEventListener(C(), m, e), window.addEventListener("keydown", c, !0), window.addEventListener("keyup", c, !0), window.addEventListener("focusin", j, !0), window.addEventListener("focusout", S, !0);
            }, U = function() {
              if (g = !(i.getAttribute("data-whatpersist") === "false" || document.body.getAttribute("data-whatpersist") === "false"), g)
                try {
                  window.sessionStorage.getItem("what-input") && (o = window.sessionStorage.getItem("what-input")), window.sessionStorage.getItem("what-intent") && (a = window.sessionStorage.getItem("what-intent"));
                } catch {
                }
              f("input"), f("intent");
            }, c = function(e) {
              var t = e.which, r = y[e.type];
              r === "pointer" && (r = k(e));
              var X = !w.length && M.indexOf(t) === -1, Y = w.length && w.indexOf(t) !== -1, L = r === "keyboard" && t && (X || Y) || r === "mouse" || r === "touch";
              if (O(r) && (L = !1), L && o !== r && (o = r, E("input", o), f("input")), L && a !== r) {
                var l = document.activeElement, q = l && l.nodeName && (T.indexOf(l.nodeName.toLowerCase()) === -1 || l.nodeName.toLowerCase() === "button" && !W(l, "form"));
                q && (a = r, E("intent", a), f("intent"));
              }
            }, f = function(e) {
              i.setAttribute("data-what" + e, e === "input" ? o : a), _(e);
            }, m = function(e) {
              var t = y[e.type];
              t === "pointer" && (t = k(e)), F(e), (!v && !O(t) || v && e.type === "wheel" || e.type === "mousewheel" || e.type === "DOMMouseScroll") && a !== t && (a = t, E("intent", a), f("intent"));
            }, j = function(e) {
              if (!e.target.nodeName) {
                S();
                return;
              }
              s = e.target.nodeName.toLowerCase(), i.setAttribute("data-whatelement", s), e.target.classList && e.target.classList.length && i.setAttribute("data-whatclasses", e.target.classList.toString().replace(" ", ","));
            }, S = function() {
              s = null, i.removeAttribute("data-whatelement"), i.removeAttribute("data-whatclasses");
            }, E = function(e, t) {
              if (g)
                try {
                  window.sessionStorage.setItem("what-" + e, t);
                } catch {
                }
            }, k = function(e) {
              return typeof e.pointerType == "number" ? D[e.pointerType] : e.pointerType === "pen" ? "touch" : e.pointerType;
            }, O = function(e) {
              var t = Date.now(), r = e === "mouse" && o === "touch" && t - x < 200;
              return x = t, r;
            }, C = function() {
              var e = null;
              return "onwheel" in document.createElement("div") ? e = "wheel" : e = document.onmousewheel !== void 0 ? "mousewheel" : "DOMMouseScroll", e;
            }, _ = function(e) {
              for (var t = 0, r = u.length; t < r; t++)
                u[t].type === e && u[t].fn.call(void 0, e === "input" ? o : a);
            }, R = function(e) {
              for (var t = 0, r = u.length; t < r; t++)
                if (u[t].fn === e)
                  return t;
            }, F = function(e) {
              h.x !== e.screenX || h.y !== e.screenY ? (v = !1, h.x = e.screenX, h.y = e.screenY) : v = !0;
            }, W = function(e, t) {
              var r = window.Element.prototype;
              if (r.matches || (r.matches = r.msMatchesSelector || r.webkitMatchesSelector), r.closest)
                return e.closest(t);
              do {
                if (e.matches(t))
                  return e;
                e = e.parentElement || e.parentNode;
              } while (e !== null && e.nodeType === 1);
              return null;
            };
            return "addEventListener" in window && Array.prototype.indexOf && A(), {
              // returns string: the current input type
              // opt: 'intent'|'input'
              // 'input' (default): returns the same value as the `data-whatinput` attribute
              // 'intent': includes `data-whatintent` value if it's different than `data-whatinput`
              ask: function(e) {
                return e === "intent" ? a : o;
              },
              // returns string: the currently focused element or null
              element: function() {
                return s;
              },
              // overwrites ignored keys with provided array
              ignoreKeys: function(e) {
                M = e;
              },
              // overwrites specific char keys to update on
              specificKeys: function(e) {
                w = e;
              },
              // attach functions to input and intent "events"
              // funct: function to fire on change
              // eventType: 'input'|'intent'
              registerOnChange: function(e, t) {
                u.push({
                  fn: e,
                  type: t || "input"
                });
              },
              unRegisterOnChange: function(e) {
                var t = R(e);
                (t || t === 0) && u.splice(t, 1);
              },
              clearStorage: function() {
                window.sessionStorage.clear();
              }
            };
          }();
        }
        /******/
      ])
    );
  });
})(P);
var $ = P.exports;
const H = /* @__PURE__ */ V($);
export {
  H as w
};
